<template>
  <div class="w-full card card-body bg-base-300">
    <div class="w-full mb-2"><img class="w-full" src="@/assets/logo.webp" alt="CityKids Logo"></div>
    <p>El acceso desde dispositivos móviles está inhabilitado.</p>
    <p>Las funcionalidades de este panel fueron diseñadas para usarse en PCs de escritorio o notebooks.</p>
  </div>
</template>
